export const getJSONBodyOrNull = (response: Response): any | null => {
  return response.headers.get('content-type')?.includes('application/json') ? response.json() : null
}
